import { Injectable, Inject } from '@angular/core';
import { ILoggerConfiguration } from '../../models/i-cloud-logger-configuration.model';
import { ILogger } from './i-logger';
import { LOG_CONFIG } from './logger-configuration';

@Injectable()
export class ConsoleLogger implements ILogger {
  public isEnabled: boolean;

  public constructor(@Inject(LOG_CONFIG) config: ILoggerConfiguration) {
    this.isEnabled = config.consoleLoggingEnabled;
  }

  public setUser(identifier: string, email: string): void {}
  public resetUser(): void {}
  public navigation(path: string) {}
  public exception(error: Error, optionalProperties?: any) {
    console.error(error, optionalProperties);
  }
  public action<T>(actionType: string, payload: T) {}

  public debug(message: any, optionalParameters?: any[]): void {
    // tslint:disable-next-line:no-console
    console.debug(message, optionalParameters);
  }

  public info(message: any, optionalParameters?: any[]): void {
    // tslint:disable-next-line:no-console
    console.info(message, optionalParameters);
  }

  public warn(message: any, optionalParameters?: any[]): void {
    // tslint:disable-next-line:no-console
    console.warn(message, optionalParameters);
  }

  public error(message: any, optionalParameters?: any[]): void {
    // tslint:disable-next-line:no-console
    console.error(message, optionalParameters);
  }
}
